/** Σφάλμα λεξικής ανάλυσης, με θέση στον πηγαίο κώδικα για εμφάνιση στον μαθητή. */
export class LexError extends Error {
  readonly line: number;
  readonly column: number;

  constructor(message: string, line: number, column: number) {
    super(message);
    this.name = 'LexError';
    this.line = line;
    this.column = column;
  }
}
